import httpclient from 'libs/Axios';

export type Availability = {
  available: boolean;
};

export interface DMDashboardData {
  leads_overview?: {
    total_leads?: number;
    source_distribution?: Record<string, number>;
    avatar?: { avatar_thumbnail?: string | null };
  };
  avatar?: { avatar_thumbnail?: string | null };
  kpi_summary: {
    campaigns_live: Availability & {
      count: number | null;
      launching_today: number | null;
    };
    qualified_leads: Availability & {
      count: number | null;
      today: number | null;
    };
    social_reach: Availability & {
      count: number | null;
      change_percentage: number | null;
    };
    website_visitors: Availability & {
      count: number | null;
      change_percentage: number | null;
    };
    hours_saved: Availability & {
      hours: number | null;
      amount_saved: number | null;
    };
  };
  content_centre: {
    social_posts: Availability & {
      count: number;
      items: any[];
      items_limit: number;
      ai_recommendation: Availability & {
        confidence: number | null;
        predicted_reach: number | null;
        predicted_leads: number | null;
        recommended_time: string | null;
        reasons: string[];
      };
    };
    parent_posts: Availability & {
      count: number;
      items: any[];
      items_limit: number;
      unavailable_fields: string[];
    };
    birthdays: Availability & {
      students_today: number;
      selfies: Availability & { received: number | null; pending: number | null };
      wishes: Availability & {
        generated: number | null;
        pending: number | null;
        failed: number | null;
      };
    };
  };
  website_performance: Availability & {
    website: {
      domain: string;
      is_live: boolean;
      activated_at: string;
      template_name: string;
      has_template: boolean;
    };
    unavailable_fields: string[];
    [key: string]: any;
  };
  content_calendar: Availability & {
    range: { start: string; end: string };
    scheduled_count: number;
    items: any[];
    items_limit: number;
    days: Array<{ date: string; count: number }>;
    unavailable_sources: string[];
  };
  parent_app_adoption: Availability & {
    invited: number | null;
    installed: number | null;
    pending: number | null;
    conversion_percentage: number | null;
    class_breakdown: Availability & { classes: any[] };
    unavailable_fields: string[];
    [key: string]: any;
  };
  digital_avatar: Availability & {
    is_online: boolean;
    thumbnail: string | null;
  };
  seo_health: Availability & {
    LOW: number;
    MEDIUM: number;
    HIGH: number;
    CRITICAL: number;
    overall_seo_percentage: number;
    total_issues: number;
  };
}

export const dashboardApi = {
  async view(): Promise<DMDashboardData> {
    const response = await httpclient().get('/master/viewDMDashboard');
    const payload = response?.data;

    if (payload?.code !== 200 || !payload?.data) {
      throw new Error(payload?.message || 'Unable to load dashboard');
    }

    return payload.data as DMDashboardData;
  },
  async viewDashboard(): Promise<DMDashboardData | null> {
    return this.view();
  },
};
